function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import ColorSettings from "./ColorSettings";

const TextColorSettings = (_ref) => {
  let _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "text" : _ref$variant,
      _ref$buttonLabel = _ref.buttonLabel,
      buttonLabel = _ref$buttonLabel === void 0 ? "T" : _ref$buttonLabel,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? "#7f7f7f" : _ref$backgroundColor,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "buttonLabel", "backgroundColor"]);

  return React.createElement(ColorSettings, _extends({}, props, {
    variant: variant,
    backgroundColor: backgroundColor
  }));
};

export default TextColorSettings;